import { render } from "./App.vue?vue&type=template&id=cb4af180"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=cb4af180&lang=css"

import exportComponent from "D:\\Users\\וינברג\\Documents\\Vue\\main-prj-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__